<template>
  <div class="contact container pt-2xl">
    <h3 class="font-md">{{localize('contact_information')}}</h3>
    <preloader v-if="!contacts.length"></preloader>
    <ul v-else class=" py-2xl flex flex-split align-stretch">
      <li
        class="pr-xl pl-xl pb-xl pt-xl mb-2xl relative"
        v-for="contact in contacts"
        :key="contact.McenterName"
      >

        <h4 class="mb-l font-md">
          <span v-text="contact.McenterName"></span>
          <span
            v-if="contact.McenterContactPerson"
            class="contact-person text-gray-8 note ml-s"
            v-text="`(${contact.McenterContactPerson})`"
          ></span>
          <!-- country name here -->
          <span class="country-top" v-text="contact.McenterCountry"></span>
        </h4>


        <p class="mb-m" v-if="contact.phone && contact.phone.length">
          <i class="fas fa-phone"></i>
          <strong>{{localize('phone_num')}}: </strong>
          <a style="direction:ltr;" :href="`tel:${contact.phone}`" v-text="contact.McenterPhone"></a>
        </p>
        <p class="mb-m">
          <i class="fas fa-envelope"></i>
          <strong>{{localize('Email')}}: </strong>
          <a style="direction:ltr;"  :href="`mailto:${contact.email}`" v-text="contact.McenterMail"></a>
        </p>
        <p class="mb-m flex flex-nowrap align-baseline">
          <i class="self-align-start fas fa-map-marker-alt"></i>
          <strong>{{localize('Address')}}: </strong>
          <span style="direction:ltr;"  class="text-gray-6" v-text="contact.McenterAddress"></span>
        </p>
        <!-- <p class="mb-s">
          <i class="fas fa-user-alt"></i>
          <span
            class="text-gray-7"
            v-text="contact.McenterContactPerson"
          ></span>
        </p> -->
        <!-- <p class="country-label" v-text="contact.McenterCountry"></p> -->
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      contacts: []
    };
  },
  mounted() {
    let vm = this;
    fetch(`${SERVER_API[ENV]}mflow/Mcenters/`, {
      method: "GET",
      headers: { t: this.userToken, u: this.userID }
    })
      .then(res => res.json())
      .then(response => {
        console.log("responose > ", response);
        vm.contacts = response;
      });
  },
  computed: {
    ...mapGetters(["userID", "userToken"])
  }
};
</script>

<style>
  .contact-person
  {
    display: block;
  }
  .country-label
  {
    /* justify-content:flex-end; */
  }
</style>

<style lang="stylus" scoped>
.contact ul li
  background #fbfbfb
  border-radius 14px
  position relative
  //box-shadow 0 0 remify(3px) rgba(gray_8, 0.3)
  //border-radius remify(3px)
  overflow hidden
  .country-top
    display block
    text-transform uppercase
    font-size remify(12px)
    font-weight 600
    color blue_brand
    padding-top 3px

  p
    _flex(row, wrap, center, flex-start)
    a
      color blue_brand
    &.country-label
      position absolute
      bottom 0
      right 0
      text-transform uppercase
      font-size remify(14px)
      font-weight 600
      color blue_brand
      //border-bottom 1px solid blue_brand
      // background linear-gradient(to left, rgba(green_4, 0.9) 25%, rgba(green_4, 0.3) 55%,rgba(green_4, 0) 90%)
      width 100%
      direction rtl
      padding remify(2px 4px)
      // text-shadow 0 0 2px rgba(green_4, 0.9)
    i
      round(24)
      flex none
      font-size remify(12px)
      line-height remify(24px)
      background gray_6
      text-align center
      color #fff
      marg('m', right)
    strong
      margin 0 0.25rem
      //marg('xs', right)
</style>
